<template>
  <div class="mail-page">
    <div v-if="loading" class="text-center g">
      <img :src="require('@/assets/images/loading.svg')" style="width: 60px" alt="">
    </div>

    <div v-else-if="error" class="card card-body text-center mail-card">
      <i class="fa fa-chain-broken fa-2x text-muted"></i>
      <h5 class="mt-1">{{ error }}</h5>
      <p class="text-muted mb-0">تأكد من الرابط الذي وصلك في الرسالة.</p>
    </div>

    <template v-else>
      <div class="mail-card card">
        <div class="mail-head">
          <span class="school"><i class="fa fa-university"></i> {{ mail.school }}</span>
          <h3>{{ mail.title }}</h3>
          <div class="meta">
            <span><i class="fa fa-calendar-o"></i> {{ mail.date }}</span>
            <span v-if="mail.signed_at" class="pill ok"><i class="fa fa-check"></i> تم التوقيع</span>
            <span v-if="mail.reply" class="pill info"><i class="fa fa-reply"></i> تم الرد</span>
          </div>
        </div>
        <div class="card-body">
          <p class="to">إلى المعلم: <strong>{{ mail.teacher }}</strong></p>
          <div class="mail-text" v-if="mail.content">{{ mail.content }}</div>
          <a v-if="mail.file" :href="mail.file" target="_blank" rel="noopener" class="file">
            <i class="fa fa-paperclip"></i>
            <span>عرض المرفق</span>
            <i class="fa fa-external-link"></i>
          </a>
        </div>
      </div>

      <!-- Done: what the teacher sent -->
      <div class="mail-card card" v-if="done && !editing">
        <div class="card-body">
          <h5 class="section-title"><i class="fa fa-check-circle text-success"></i> تم إرسال إقرارك</h5>
          <div v-if="mail.signature" class="sent-sign">
            <small class="text-muted">التوقيع · {{ mail.signed_at }}</small>
            <img :src="mail.signature" alt="التوقيع">
          </div>
          <div v-if="mail.reply" class="sent-reply">
            <small class="text-muted">ردك<span v-if="mail.replied_at"> · {{ mail.replied_at }}</span></small>
            <p class="mb-0">{{ mail.reply }}</p>
          </div>
          <button class="btn btn-outline-primary btn-block mt-1" @click="editing = true">
            <i class="fa fa-pencil"></i> تعديل الرد أو التوقيع
          </button>
        </div>
      </div>

      <!-- Sign and / or reply -->
      <div class="mail-card card" v-else>
        <div class="card-body">
          <h5 class="section-title"><i class="fa fa-pencil-square-o"></i> إقرار الاستلام</h5>
          <p class="text-muted small">وقّع لتأكيد استلامك للتعميم، أو اكتب ردك، أو الاثنين. كلاهما اختياري.</p>
          <label class="field-label">التوقيع</label>
          <signature-pad ref="pad" @change="empty => signed = !empty"></signature-pad>
          <label class="field-label mt-1" for="mail-reply">الرد</label>
          <textarea id="mail-reply" class="form-control" v-model="reply" rows="3" placeholder="اكتب ردك هنا (اختياري)"></textarea>
          <button class="btn btn-primary btn-block btn-lg mt-1" :disabled="sending || (!signed && !reply.trim())" @click="send()">
            <i class="fa fa-paper-plane"></i>
            {{ sending ? 'جاري الإرسال...' : (signed && reply.trim() ? 'إرسال التوقيع والرد' : signed ? 'إرسال التوقيع' : 'إرسال الرد') }}
          </button>
          <button v-if="done" class="btn btn-link btn-block" @click="editing = false">إلغاء</button>
        </div>
      </div>
    </template>

    <p class="text-center text-muted small mt-1">الخدمة مقدمة من <a href="https://tahdir.net">التحضير الذكي</a></p>
  </div>
</template>

<script>
import SignaturePad from '../components/SignaturePad.vue';

// Teacher's circular page (/mail/<mail id>/<teacher id>): read, then optionally sign and/or reply.
export default {
  components: { SignaturePad },
  data() {
    var parts = window.location.pathname.split('/mail/')[1]?.split('/') ?? [];
    return {
      id: parts[0] || '', subid: parts[1] || '',
      loading: true, error: '', mail: {}, reply: '', signed: false,
      sending: false, editing: false,
    };
  },
  computed: {
    done() {
      return !!(this.mail.signature || this.mail.reply);
    },
  },
  created() {
    var g = this;
    $.post(api + '/general/mail2/view', { id: this.id, subid: this.subid }).then(function(r){
      g.loading = false;
      if(r.status != 100) return (g.error = r.response);
      g.mail = r.response;
      g.reply = r.response.reply || '';
    }).fail(function(){
      g.loading = false;
      g.error = 'تعذر الاتصال، حاول مرة أخرى.';
    });
  },
  methods: {
    send() {
      var g = this;
      var signature = this.$refs.pad ? this.$refs.pad.toDataURL() : '';
      g.sending = true;
      $.post(api + '/general/mail2/reply', {
        id: this.id, subid: this.subid, reply: this.reply.trim(), signature: signature,
      }).then(function(r){
        g.sending = false;
        if(r.status != 100) return alert(r.response, 200);
        g.mail = Object.assign({}, g.mail, r.response);
        g.editing = false;
        g.signed = false;
        alert('تم الإرسال، شكراً لك.', 100);
      }).fail(function(){
        g.sending = false;
        alert('تعذر الاتصال، حاول مرة أخرى.', 200);
      });
    },
  },
};
</script>

<style scoped>
.mail-page {
  max-width: 640px;
  margin: 0 auto;
  padding: 16px 12px 24px;
}
.mail-card {
  border-radius: 18px;
  overflow: hidden;
  margin-bottom: 14px;
}
.mail-head {
  background: linear-gradient(135deg, var(--sk-p, #1D4ED8), var(--sk-pi, #1E3A8A));
  color: #fff;
  padding: 18px 18px 16px;
}
.mail-head h3 {
  color: #fff;
  margin: 6px 0 8px;
  font-weight: 800;
  line-height: 1.5;
}
.mail-head .school {
  opacity: 0.85;
  font-size: 13px;
}
.mail-head .meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  font-size: 12.5px;
  opacity: 0.95;
}
.pill {
  border-radius: 999px;
  padding: 2px 10px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.18);
}
.to {
  color: var(--sk-muted, #667085);
  margin-bottom: 10px;
}
.mail-text {
  white-space: pre-line;
  line-height: 2;
  font-size: 15px;
  color: var(--sk-ink, #0F1733);
}
.file {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  padding: 12px 14px;
  border: 1px solid var(--sk-line, #D5DAE3);
  border-radius: 12px;
  background: var(--sk-soft, #F6F7FB);
  font-weight: 700;
}
.file span {
  flex: 1;
}
.section-title {
  font-weight: 800;
  margin-bottom: 6px;
}
.field-label {
  display: block;
  margin-bottom: 6px;
}
.sent-sign img {
  display: block;
  max-width: 100%;
  max-height: 150px;
  margin-top: 6px;
  background: #fff;
  border: 1px solid var(--sk-line2, #E6E9EF);
  border-radius: 12px;
  padding: 6px 12px;
}
.sent-reply {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--sk-soft, #F6F7FB);
  white-space: pre-line;
}
</style>
